"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var createGetMemoizedRef = function createGetMemoizedRef() {
  var cachedRefs = [];

  var memoizedRef = function memoizedRef(element) {
    cachedRefs.forEach(function (ref) {
      return ref && ref(element);
    });
  };

  return function () {
    for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
      refs[_key] = arguments[_key];
    }

    cachedRefs = refs;
    return memoizedRef;
  };
};

var _default = createGetMemoizedRef;
exports.default = _default;